import { Triangle } from '@phosphor-icons/react';

const Divider = () => {
  return (
    <div className="flex h-full flex-col items-center gap-y-3">
      <div className="h-full rounded-full border-2 border-primary-700"></div>
      {/* ICONS */}
      <div className="flex flex-col gap-y-2">
        <Triangle
          size={25}
          weight="bold"
          className="rotate-90 text-primary-700"
        />
        <Triangle
          size={25}
          weight="bold"
          className="-rotate-90 text-primary-700"
        />
      </div>
      <div className="h-full rounded-full border-2 border-primary-700"></div>
    </div>
  );
};

export default Divider;
